/**
 * @flow
 * @relayHash 23dced8d6a31b4f1022e221adba046b9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CashWithheldStatus = "RE" | "WH" | "%future added value";
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
export type ReleaseWithheldCashMutationVariables = {|
  withheldCashId: string
|};
export type ReleaseWithheldCashMutationResponse = {|
  +releaseWithheldCash: ?{|
    +cashWithheld: ?{|
      +id: string,
      +amount: number,
      +createdAt: any,
      +updatedAt: any,
      +currency: Currency,
      +status: CashWithheldStatus,
      +notes: ?{|
        +id: string
      |},
    |}
  |}
|};
export type ReleaseWithheldCashMutation = {|
  variables: ReleaseWithheldCashMutationVariables,
  response: ReleaseWithheldCashMutationResponse,
|};
*/


/*
mutation ReleaseWithheldCashMutation(
  $withheldCashId: ID!
) {
  releaseWithheldCash(withheldCashId: $withheldCashId) {
    cashWithheld {
      id
      amount
      createdAt
      updatedAt
      currency
      status
      notes {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "withheldCashId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "releaseWithheldCash",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "withheldCashId",
        "variableName": "withheldCashId"
      }
    ],
    "concreteType": "ReleaseWithheldCash",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cashWithheld",
        "storageKey": null,
        "args": null,
        "concreteType": "CashWithheldNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "updatedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "currency",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "notes",
            "storageKey": null,
            "args": null,
            "concreteType": "NotesNode",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ReleaseWithheldCashMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ReleaseWithheldCashMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ReleaseWithheldCashMutation",
    "id": null,
    "text": "mutation ReleaseWithheldCashMutation(\n  $withheldCashId: ID!\n) {\n  releaseWithheldCash(withheldCashId: $withheldCashId) {\n    cashWithheld {\n      id\n      amount\n      createdAt\n      updatedAt\n      currency\n      status\n      notes {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '233cbde4c9c49a462173ca5e6177d6ec';
module.exports = node;
